import { toUtcAdjusted } from '@noor/lib';
import type { SelfEmployedListSearch } from '../model/list-params';

/** Export / base payload (no paging). */
export interface SelfEmployedFilter {
  from: string;
  till: string;
  search?: string;
  self_employment_status_set?: boolean;
}

/** List payload: the filter plus paging. */
export interface SelfEmployedListFilter extends SelfEmployedFilter {
  limit: number;
  skip: number;
}

const DAY_FORMAT = 'YYYY-MM-DD';

/**
 * Build the report filter from URL params (cpanel `buildSelfEmployedFilter`):
 * a UTC-adjusted day window, a trimmed search, and the status tab mapped onto
 * the backend's `self_employment_status_set` flag (`all` sends nothing).
 */
export function buildSelfEmployedFilter(search: SelfEmployedListSearch): {
  filter: SelfEmployedFilter;
  listFilter: SelfEmployedListFilter;
} {
  const term = search.search?.trim() ?? '';
  const statusSet =
    search.status_filter === 'confirmed'
      ? true
      : search.status_filter === 'unconfirmed'
        ? false
        : undefined;
  const filter: SelfEmployedFilter = {
    from: toUtcAdjusted(search.start_date).format(DAY_FORMAT),
    till: toUtcAdjusted(search.end_date).format(DAY_FORMAT),
    ...(term ? { search: term } : {}),
    ...(statusSet !== undefined ? { self_employment_status_set: statusSet } : {}),
  };
  return {
    filter,
    listFilter: {
      ...filter,
      limit: search.pageSize,
      skip: (search.page - 1) * search.pageSize,
    },
  };
}
